export default "__VITE_ASSET__BeZH1Lvn__"